/** @jsxImportSource @emotion/react */

import { useMutation } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { createSearchParams, useSearchParams } from 'react-router-dom'
import slugify from 'slugify'
import { CREATE_ACHIEVEMENT } from 'queries/achievements'
import { createAchievement, createAchievementVariables } from '__generatedTypes__/createAchievement'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { PlatformSlug } from 'constants/consts'
import { toast } from 'utils/toast'
import * as classes from '../styles'
import { AwardsTabs, QUERY_PARAM, ORDER_PARAM } from '../consts'
import { Form, FormValues } from './Form'
import { MEMBERSHIP_EXTENSION_AWARD_TYPE } from './consts'

type Props = {
  platform: Platform
}

export const AchievementCreate = withPlatformCheck(({ platform }: Props) => {
  const [searchParams] = useSearchParams()
  const { navigate } = useLink()

  const [createAchievement] = useMutation<createAchievement, createAchievementVariables>(CREATE_ACHIEVEMENT)
  const handleSubmit = async (values: FormValues) => {
    const { awardType: awardTypeOption, type, level, ...rest } = values

    const { awardType, awardTypeValue } = MEMBERSHIP_EXTENSION_AWARD_TYPE[awardTypeOption?.id]

    try {
      await createAchievement({
        variables: {
          createAchievementInput: {
            ...rest,
            isLive: false,
            order: Number(searchParams.get(ORDER_PARAM) || 0),
            type: type.id,
            awardType,
            awardTypeValue,
            level: Number(level.id),
            platform: { id: platform.id },
          },
        },
      })
      navigate(cmsRoutes.ACHIEVEMENTS, undefined, {
        searchParams: createSearchParams({
          [QUERY_PARAM]: slugify(AwardsTabs.ACHIEVEMENTS, { lower: true }),
        }),
      })

      toast.success('Achievement created successfully')
    } catch (error) {
      toast.error('Failed to create achievement')
    }
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.title} variant="title3">
        Achievements
      </Typography>
      <Form onSubmit={handleSubmit} platform={platform.slug as PlatformSlug} />
    </section>
  )
})
